import { make } from 'vuex-pathify';
var state = {
  aberto: false,
  mensagens: 0
};
var mutations = {
  incrementarMensagens: function incrementarMensagens(state) {
    state.mensagens += 1;
  }
};
var actions = {};
var getters = {
  aberto: function aberto(state) {
    return state.aberto;
  },
  mensagens: function mensagens(state) {
    return state.mensagens;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};